// @ts-ignore
__webpack_public_path__ = document
  .getElementsByTagName('base')[0]
  .getAttribute('href');
